import { env } from "process";
import { APP_URL } from "~/utils/constants";

export const getCheckinURL = (event: {
    id: string;
    eventBadges:
        | {
              id: string;
              path: string;
          }[]
        | null;
}) => {
    return event.eventBadges && event.eventBadges.length > 0
        ? `${APP_URL}/eventId/${event.id}/checkin/badges`
        : `${APP_URL}/eventId/${event.id}/checkin/guest`;
};

export const generateCheckinQRCode = async (
    event: {
        id: string;
        eventBadges:
            | {
                  id: string;
                  path: string;
              }[]
            | null;
    },
    community?: { id: string; image?: string | null } | null,
) => {
    const checkinURL = getCheckinURL(event);

    // If no badges or the first badge is wrongly saved, use a simple QR code without the badge
    if (
        !event.eventBadges ||
        event.eventBadges.length === 0 ||
        !event.eventBadges.at(0)?.path.endsWith("png")
    )
        return `${APP_URL}/api/og/qr?size=300&data=${checkinURL}`;

    const logo =
        event.eventBadges[0]?.path ??
        `${env.NEXT_PUBLIC_ASSETS_URL}/community/${community?.id}/${community?.image}`;

    return `${APP_URL}/api/og/qr?size=300&logo=${encodeURIComponent(logo)}&data=${encodeURIComponent(checkinURL)}`;
};
